import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { AuthContext } from "../context/AuthContext";

const AuthenticatedRoute = ({ children }) => {
  const { usuario, authLoading } = useContext(AuthContext);
  const location = useLocation();
  const token = localStorage.getItem("token");

  if (authLoading) {
    return (
      <section className="container page-shell">
        <div className="surface-card">
          <p className="mb-0">Validando sesion...</p>
        </div>
      </section>
    );
  }

  if (!token || !usuario) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children || <Outlet />;
};

export default AuthenticatedRoute;
